import { render, staticRenderFns } from "./SignPad.vue?vue&type=template&id=833a9fa6&scoped=true&"
import script from "./SignPad.vue?vue&type=script&lang=js&"
export * from "./SignPad.vue?vue&type=script&lang=js&"
import style0 from "./SignPad.vue?vue&type=style&index=0&id=833a9fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833a9fa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('833a9fa6')) {
      api.createRecord('833a9fa6', component.options)
    } else {
      api.reload('833a9fa6', component.options)
    }
    module.hot.accept("./SignPad.vue?vue&type=template&id=833a9fa6&scoped=true&", function () {
      api.rerender('833a9fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/SignPad.vue"
export default component.exports